/**
 * Toolbar with display toggles and selection action buttons.
 */

import React from 'react';
import {
  Grid3X3,
  Tag,
  Flame,
  Radio,
  RotateCcw,
  Trash2,
} from 'lucide-react';
import { useLayoutEditor } from '../contexts/LayoutEditorContext';
import { createEmptyLayout } from '../utils/layoutStorage';

const EditorToolbar: React.FC = () => {
  const { state, dispatch, warehouseId } = useLayoutEditor();
  const { editorState } = state;

  const handleResetLayout = () => {
    if (window.confirm('Er du sikker på at du vil nullstille layouten? Alle reolplasseringer vil bli fjernet.')) {
      dispatch({ type: 'RESET_LAYOUT', emptyLayout: createEmptyLayout(warehouseId, state.layout?.name) });
    }
  };

  return (
    <div className="p-3 border-b border-gray-200">
      <div className="flex flex-wrap gap-1">
        <button
          onClick={() => dispatch({ type: 'TOGGLE_EDITOR_OPTION', option: 'showGrid' })}
          className={`p-2 rounded ${editorState.showGrid ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'}`}
          title="Vis rutenett"
        >
          <Grid3X3 className="w-4 h-4" />
        </button>
        <button
          onClick={() => dispatch({ type: 'TOGGLE_EDITOR_OPTION', option: 'showLabels' })}
          className={`p-2 rounded ${editorState.showLabels ? 'bg-blue-100 text-blue-600' : 'hover:bg-gray-100'}`}
          title="Vis etiketter"
        >
          <Tag className="w-4 h-4" />
        </button>
        <button
          onClick={() => dispatch({ type: 'TOGGLE_EDITOR_OPTION', option: 'showHeatmap' })}
          className={`p-2 rounded ${editorState.showHeatmap ? 'bg-orange-100 text-orange-600' : 'hover:bg-gray-100'}`}
          title="Vis heatmap"
        >
          <Flame className="w-4 h-4" />
        </button>
        <button
          onClick={() => dispatch({ type: 'TOGGLE_EDITOR_OPTION', option: 'showActivity' })}
          className={`p-2 rounded ${editorState.showActivity ? 'bg-green-100 text-green-600' : 'hover:bg-gray-100'}`}
          title="Vis aktivitet"
        >
          <Radio className="w-4 h-4" />
        </button>

        <div className="w-px h-6 bg-gray-200 mx-1 self-center" />

        {editorState.selectedRacks.size > 0 && (
          <>
            <button
              onClick={() => dispatch({ type: 'ROTATE_SELECTED' })}
              className="p-2 rounded hover:bg-gray-100"
              title="Roter valgte (R)"
            >
              <RotateCcw className="w-4 h-4" />
            </button>
            <button
              onClick={() => dispatch({ type: 'DELETE_SELECTED' })}
              className="p-2 rounded hover:bg-red-100 text-red-600"
              title="Slett valgte (Delete)"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </>
        )}

        <button
          onClick={handleResetLayout}
          className="p-2 rounded hover:bg-red-100 text-red-600"
          title="Nullstill layout"
        >
          <RotateCcw className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default EditorToolbar;
